import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

function BackButton({ url }) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(url)}
      className="btn btn-primary shadow-md hover:shadow-lg flex items-center gap-2 rounded-full transition-all duration-200 hover:gap-3 px-4 py-2"
    >
      <ChevronLeft size={18} className="transition-transform" />
      <span>Back</span>
    </button>
  );
}

export default React.memo(BackButton);
